import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  LinearProgressProps,
} from "@mui/material"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { Users } from "lucide-react"
const textColor = "#0d2561"
const itextColor = "#707070"
export default function InefficienciesWidget() {
  const lateTaskResponses = 75
  const dealsWithoutServiceProviders = 15

  const bottlenecks = [
    { stage: "Contract", delay: 10 },
    { stage: "Diligence", delay: 25 },
    { stage: "Mortgage", delay: 50 },
    { stage: "Ownership", delay: 35 },
    { stage: "Closing", delay: 40 },
  ]

  return (
    <Card>
      
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1, fontSize:'1.20rem' }}>
          Inefficiencies
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Number of proposals received and their status (active/no longer active).
        </Typography>
        <Box display="flex" flexDirection="column" gap={3} mt={2}>
          {/* Late Task Responses */}
          <Box display="flex" gap={2} alignItems="center">
            <AccessTimeIcon sx={{ color: "#f97316", width:'20px', height:'20px' }} />
            <Box>
              <Typography variant="h6" sx={{ color: "#f97316",fontSize:'18px',fontWeight:'bold' }}>
                {lateTaskResponses}%
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{fontSize:'14px'}}>
                Late task responses (of all delays)
              </Typography>
            </Box>
          </Box>

          {/* Bottlenecks */}
          <Box>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom style={{ color: textColor}}>
              Bottlenecks (Delay %)
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
              {bottlenecks.map((item, index) => (
                <Box key={index}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2" fontWeight={500}>
                      {item.stage}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.delay}%
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={item.delay}
                    sx={{
                      height: 16,
                      borderRadius: 4,
                      backgroundColor: "#EAF0F5",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: textColor,
                      },
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Box>

          {/* Deals without Service Providers */}
          <Box display="flex" gap={2} alignItems="center">
            <Users className="h-5 w-5 text-primary" style={{ fontWeight:600, width:'20px',height:'20px' }}/>
            <Box>
              <Typography  sx={{ color: textColor,fontSize:'18px',fontWeight:'bold' }}>
                {dealsWithoutServiceProviders}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Deals without service providers
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
